<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div fxLayout="column" id="itemRecordContainer">
  <record-text [text]="record.text"></record-text>
  <div *ngIf="record.image" id="recordImageContainer">
    <record-image [images]="[record.image]"></record-image>
  </div>
</div>
